import "slick-carousel/slick/slick";
import $ from "jquery";
import gsap from "gsap";

$(".frontpage-slider__container").slick({
	arrows: false,
	autoplay: true,
	fade: true,
	speed: 1800,
	autoplaySpeed: 8000,
});

function navInitAnimation() {
	gsap.from(".nav-item", {
		duration: 1,
		ease: "power3.out",
		y: `-${document.querySelector(".nav__container").offsetHeight}px`,
		stagger: {
			each: 0.08,
			from: "center",
		},
		delay: 0.5,
	});
}

window.onload = navInitAnimation;
